import React from "react";
import { useDispatch } from "react-redux";

import { Button } from "rhombus-react";

import { closeModal } from "reducers/Modal";

import BasicModal from "widgets/modals/BasicModal";
import CreativesTable from "widgets/table/CreativesTable";

import "./DeleteCreativesErrors.css";

export default function DeleteCreativesErrors(props){
	const { creatives, assigned } = props;
	const dispatch = useDispatch();

	const assignedSet = new Set(assigned);
	const assignedCreatives =creatives.filter(creative => assignedSet.has(creative.id));

	function onClose(){
		dispatch(closeModal());
	}

	function renderContent(){
		return (
			<div>
				<p className="message">
					Cannot delete the following creatives because they are assigned to placements.
				</p>
				<CreativesTable
					creatives = {assignedCreatives}
					shouldLinkPreview = {false}
				/>
			</div>
		);
	}

	function renderFooter(){
		return <Button theme="default" onClick={onClose}>Close</Button>;
	}

	const modalProps = {
		title: "Delete Creative Error",
		className: "delete-creatives-errors-modal",
		renderContent,
		renderFooter,
		onClose,
	};

	return (
		<BasicModal {...modalProps} />
	);
}

DeleteCreativesErrors.displayName = "DeleteCreativesErrorsModal";
DeleteCreativesErrors.defaultProps = {
	creatives: [],
	assigned: [],
};
